import Vue from 'vue';
import axios from 'axios';
import Pusher from 'pusher-js';
import Echo from 'laravel-echo';
import VueTimeago from 'vue-timeago';
import VueCookies from 'vue-cookies';

Vue.use(VueCookies);

Vue.use(VueTimeago, {
  locale: 'en-UK',
});

window.Vue = Vue;
window.Pusher = Pusher;
if (typeof ($) != "undefined") {
  // Load jquery from metronic
  window.jQuery = window.$ = $;
} else {
  // Load jquery from npm
  window.$ = window.jQuery = require('jquery');
}
window.cookies = Vue.$cookies;
window.moment = require('moment');

// Configure Laravel Echo
if (window.app_type === 'app' || window.app_type === 'admin') {
  const { key, cluster } = window.Laravel.pusher;
  if (key) {
    window.Echo = new Echo({
      broadcaster: 'pusher',
      key: key,
      cluster: cluster,
      forceTLS: true,
    });

    axios.interceptors.request.use(
      (config) => {
        config.headers['X-Socket-ID'] = window.Echo.socketId();
        return config;
      },
      error => Promise.reject(error),
    );
  }
}

window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
const csrf = document.querySelector('meta[name="csrf-token"]');
if (csrf) {
  window.token = csrf.getAttribute('content');
  window.axios.defaults.headers.common["X-CSRF-TOKEN"] = window.token;
} else {
  console.error("CSRF token not found!");
}
